import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bytesizeIcon', standalone: true })
export class BytesizeIconPipe implements PipeTransform {
  transform(value: string): string {
    return '/assets/core/icons/bytesize-icon.svg' + value;
  }
}
